import { AcceptanceLanguageEnum } from 'global/Securities/types/termsAndCondition';
import exodusInstance from './instances/exodus';
import { APIResponse } from '../../../@types/api-response';

const request = exodusInstance.withLanguageInstance(
  AcceptanceLanguageEnum.ENGLISH,
  true,
);
const requestWithoutAlert = exodusInstance.withLanguageInstance(
  AcceptanceLanguageEnum.ENGLISH,
  false,
);

export const requestOtpNewDevice = ({ token, channel }): Promise<APIResponse> =>
  request.post('/login/v3/new-device/otp', { token, channel });

export const verifyOtpNewDevice = ({ token, otp }): Promise<APIResponse> =>
  requestWithoutAlert.post('/login/v3/new-device/otp/verify', { token, otp });

export const requestVerifyIdentity = ({
  token,
  identity,
  birthDate,
  bankAccountNumber,
  motherName,
}): Promise<APIResponse> =>
  requestWithoutAlert.post('login/v4/recovery/identity/validate', {
    token,
    identity,
    birth_date: birthDate,
    bank_account_number: bankAccountNumber,
    mother_name: motherName,
  });

export const requestVerifyPassword = ({
  token,
  password,
}): Promise<APIResponse> =>
  request.post('login/v4/recovery/password/validate', { token, password });

export const requestVerifyPin = ({ token, pin }): Promise<APIResponse> =>
  request.post('login/v4/recovery/pin/validate', { token, pin });

export const requestOtpTrustedDevice = ({
  token,
  channel,
}): Promise<APIResponse> =>
  request.post('login/v4/recovery/otp', { token, channel });

export const verifyOtpTrustedDevice = ({ token, otp }): Promise<APIResponse> =>
  requestWithoutAlert.post('login/v4/recovery/otp/verify', { token, otp });

export const requestSendPrompt = ({ token }): Promise<APIResponse> =>
  requestWithoutAlert.post('login/v4/new-device/prompt/send', { token });

export const getPromptResult = (token: string): Promise<APIResponse> =>
  requestWithoutAlert.get('mfa/v1/prompt/verified/result', {
    params: {
      token,
    },
  });

export const verifyPromptRequest = ({
  token,
  acknowledgeToken,
}): Promise<APIResponse> =>
  requestWithoutAlert.post('login/v4/new-device/prompt/verify', {
    token,
    acknowledge_token: acknowledgeToken,
  });

export const requestForgotPin = ({ token }): Promise<APIResponse> =>
  request.post('login/v4/recovery/pin/forgot', {
    token,
  });
